import { AGENCIES } from 'constants/constants';

export function filterAgenciesByOrigin(agencies = [], origin = '') {
  if (!agencies?.length || !origin) return [];

  const allowedAgencies = Object.entries(AGENCIES).reduce(
    (accumulator, [key, data]) =>
      data.allowedTo.includes(origin)
        ? [...accumulator, key]
        : [...accumulator],
    [],
  );

  return agencies?.filter((agency) =>
    allowedAgencies.includes(agency.agency_code),
  );
}
